import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45781083"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "search-results-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Organisations", -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "row"
}
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Teams", -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "label label-default"
}
const _hoisted_16 = {
  key: 2,
  class: "row"
}
const _hoisted_17 = { class: "col-sm-12" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Other groups", -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "label label-default"
}
const _hoisted_21 = {
  key: 3,
  class: "row"
}
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Users", -1))
const _hoisted_24 = ["href"]
const _hoisted_25 = {
  key: 0,
  class: "label label-default"
}

import axios from "axios";
import { debug as d } from "debug";
import { computed, onMounted, ref, watch } from "vue";
import {
  GroupDescriptionApiModel,
  OrganisationDescriptionApiModel,
  ShortUserDetailsApiModel,
} from "../../api-models";

export interface AdminSearchResults {
  Users: ShortUserDetailsApiModel[];
  Teams: GroupDescriptionApiModel[];
  OtherGroups: GroupDescriptionApiModel[];
  Organisations: OrganisationDescriptionApiModel[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'admin-search-page',
  setup(__props) {

const debug = d("cs.AdminSearchPage");

const query = ref<string>("");
const model = ref<AdminSearchResults | null>(null);
const serverCallTimeout = ref<any>(null);
const isLoading = ref<boolean>(false);

const totalResultsCount = computed(() => {
  if (!model.value) {
    return 0;
  }

  const orgCount = model.value.Organisations.length;
  const userCount = model.value.Users.length;
  const teamsCount = model.value.Teams.length;
  const otherGroupsCount = model.value.OtherGroups.length;
  return orgCount + userCount + teamsCount + otherGroupsCount;
});

function performSearch(): void {
  if (!query.value || query.value.trim().length < 3) {
    model.value = null;
    return;
  }

  // Simple debounce to avoid hammering the server
  if (serverCallTimeout.value) {
    clearTimeout(serverCallTimeout.value);
  }
  serverCallTimeout.value = setTimeout(() => {
    const queryValue = query.value.trim();
    debug("Searching", queryValue);
    isLoading.value = true;
    serverCallTimeout.value = null;
    axios.get(`/admin/search/query?q=${queryValue}`).then((resp) => {
      const modelValue = resp.data as AdminSearchResults;
      model.value = modelValue;
      debug(`Got results for: ${queryValue}`);
      isLoading.value = false;
    });
  }, 500);
}

watch(query, () => {
  performSearch();
});

onMounted(() => {
  debug("Mounted");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["admin-search", { 'has-results': totalResultsCount.value > 0 }]),
    style: {"margin-top":"20px"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (totalResultsCount.value > 0)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Search results:"))
          : _createCommentVNode("", true),
        (model.value && totalResultsCount.value == 0)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, "No results for '" + _toDisplayString(query.value) + "'.", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("form", {
        class: "col-sm-4",
        onSubmit: _withModifiers(performSearch, ["prevent"]),
        autocomplete: "off"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["input-wrapper form-control form-control-lg search-input-wrapper", { loading: !!serverCallTimeout.value || isLoading.value }])
        }, [
          _withDirectives(_createElementVNode("input", {
            class: "",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
            placeholder: "Search..."
          }, null, 512), [
            [_vModelText, query.value]
          ])
        ], 2)
      ], 32)
    ]),
    _hoisted_5,
    (model.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (model.value.Organisations.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value.Organisations, (organisation) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "search-result group-search-result",
                      key: organisation.id
                    }, [
                      _createElementVNode("a", {
                        href: '/organisation/details/' + organisation.id
                      }, _toDisplayString(organisation.name), 9, _hoisted_10)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (model.value.Teams.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value.Teams, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "search-result group-search-result",
                      key: group.id
                    }, [
                      _createElementVNode("a", {
                        href: '/admin/group/details/' + group.id
                      }, _toDisplayString(group.name), 9, _hoisted_14),
                      (group.organisation)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(group.organisation.name), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (model.value.OtherGroups.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value.OtherGroups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "search-result group-search-result",
                      key: group.id
                    }, [
                      _createElementVNode("a", {
                        href: '/admin/group/details/' + group.id
                      }, _toDisplayString(group.name), 9, _hoisted_19),
                      (group.organisation)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(group.organisation.name), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (model.value.Users.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value.Users, (user) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "search-result user-search-result",
                      key: user.id
                    }, [
                      _createElementVNode("a", {
                        href: '/admin/user/details/' + user.id
                      }, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName) + " <" + _toDisplayString(user.email) + ">", 9, _hoisted_24),
                      (user.organisation)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(user.organisation.name), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})